import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button, Tabs, Tab } from '@mui/material';
import Home from '../../../components/Home/HomeBox'
import CaseloadReport from '../../../components/Reports_V2/CaseloadReport'
import TimesheetsReport from '../../../components/Reports_V2/TimesheetsReport'
import IRecordSync from '../../../components/forms/BulkUploadForm/IRecordSync'
import NewNote from '../../SupportCoordinator/Modals/NewNote';
import NewTask from '../../SupportCoordinator/Modals/NewTask';
import NewTimesheet from '../../SupportCoordinator/Modals/NewTimesheet';
import Upload from '../../SupportCoordinator/Modals/Upload';
import WorkflowFormDialog from 'src/components/forms/WorkflowForm/WorkflowFormDialog';
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';
import moment from 'moment';
import axios from 'axios'
import { APIURL } from '../../../config'

const ServiceProviderEmployeeHome = (props) => {
    const [value, setValue] = useState('1');
    const [showWorkflow, setShowWorkflow] = useState(false);

    const [showAddNote, setShowAddNote] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [showTask, setShowTask] = useState(false);
    const [showTimesheet, setShowTimesheet] = useState(false);

    const [noteCustomerID, setNoteCustomerID] = useState();
    const [uploadCustomerID, setUploadCustomerID] = useState("");
    const [timesheetCustomerID, setTimesheetCustomerID] = useState("")

    const handleShowTask = () => setShowTask(true);
    const handleCloseTask = () => setShowTask(false);
    const handleShowTimesheet = (id) => { setTimesheetCustomerID(id); setShowTimesheet(true) };
    const handleCloseTimesheet = () => setShowTimesheet(false);

    const isAdmin = props.user.type === 'Admin';
    const isSubscibedToTimeManagement = props.user.subs.find((setting) => setting.feature_id === 12) ? true : false;
    const isSubscibedToBIandReporting = props.user.subs.find((setting) => setting.feature_id === 16) ? true : false;
    const isNJ = props.user.comp_settings.find(setting => setting.feature_id === 99 && setting.state_id === 'NJ');
    const isSupport = props.user.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') && isNJ;

    useEffect(() => {
        const checkTokenExpiry = () => {
            props.checkTokenExpiry();
        };
        checkTokenExpiry();
    }, [props])

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    value={value}
                >
                    <Tab onClick={() => setValue('1')} label="Home" value="1" />
                    {isAdmin && <Tab onClick={() => setValue('2')} label="Caseload Report" value="2" />}
                    {isSubscibedToTimeManagement && <Tab onClick={() => setValue('3')} label="Timesheets Report" value="3" />}
                    {isAdmin && isSubscibedToBIandReporting && <Tab onClick={() => setValue('4')} label="Dashboard" value="4" />}
                    {props.user.type !== 'Fieldworker' && isSupport && <Tab onClick={() => setValue('5')} label="DDD Sync" value="5" />}
                </Tabs>
                <ButtonGroup size="small" sx={{ height: "40px", whiteSpace: "nowrap" }}>
                    <Button variant="contained" onClick={() => setShowAddNote(true)}>NEW NOTE</Button>
                    <Button variant="contained" onClick={handleShowTask}>NEW TASK</Button>
                    {isSubscibedToTimeManagement && <Button variant="contained" onClick={handleShowTimesheet}>NEW TIMESHEET</Button>}
                    {props.user.permissions.CreateNewWorkflow && <Button size="small" variant="contained" onClick={() => setShowWorkflow(true)}>NEW WORKFLOW</Button>}
                    <Button size="small" variant="contained" onClick={() => setShowUpload(true)}>UPLOAD</Button>
                </ButtonGroup>
            </div>
            {value === '1' &&
                <GridLayoutComponent
                    {...props}
                    checkTokenExpiry={props.checkTokenExpiry}
                    user={props.user}
                    comp_id={props.comp_id}
                    handleShowTimesheet={handleShowTimesheet}
                />
            }
            {value === '2' &&
                <div>
                    <CaseloadReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                </div>
            }
            {value === '3' &&
                <div style={{ width: '98%' }}>
                    <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                </div>
            }
            {value === '4' &&
                <div>
                    <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                </div>
            }
            {value === '5' && isSupport &&
                <div>
                    <IRecordSync comp_id={props.comp_id} {...props}></IRecordSync>
                </div>
            }
            <div>
                <NewNote checkTokenExpiry={props.checkTokenExpiry} showAddNote={showAddNote} setShowAddNote={setShowAddNote} company_id={props.comp_id} mode='add' user={props.user} customer_id={noteCustomerID} setNoteCustomerID={setNoteCustomerID}></NewNote>
                <NewTask show={showTask} handleClose={handleCloseTask} user={props.user} emp_id={props.user.emp_id} comp_id={props.comp_id} {...props} />
                <NewTimesheet show={showTimesheet} handleClose={handleCloseTimesheet} comp_id={props.comp_id} user={props.user} emp_id={props.user.emp_id} customer_id={timesheetCustomerID} setTimesheetCustomerID={setTimesheetCustomerID}></NewTimesheet>
                <WorkflowFormDialog {...props} open={showWorkflow} handleClose={() => setShowWorkflow(false)} />
                <Upload showUpload={showUpload} setShowUpload={setShowUpload} company_id={props.comp_id} user={props.user} customer_id={uploadCustomerID} setUploadCustomerID={setUploadCustomerID}></Upload>
            </div>
        </div>
    )
}

export default ServiceProviderEmployeeHome;